export const NumTreeCircleIcon = () => {
    return (
        <svg width="100%" height="100%" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="20" cy="20.5791" r="18.6667" stroke="url(#paint0_linear_971_23865)" strokeWidth="2.66667"/>
            <path
                d="M26.208 25.2151C26.208 28.8391 23.532 30.9391 19.8 30.9391C16.56 30.9391 13.692 29.3551 12.96 25.4671L15.96 25.0111C16.368 27.0151 17.484 28.2271 19.86 28.2271C21.852 28.2271 23.172 26.9191 23.172 25.3351C23.172 23.5111 21.912 22.5511 19.8 22.5511H17.796V20.2231L21.948 16.0111H13.932V13.2991H25.5V16.0111L21.228 20.2951C24.456 20.6431 26.208 22.2751 26.208 25.2151Z"
                fill="url(#paint1_linear_971_23865)"/>
            <defs>
                <linearGradient id="paint0_linear_971_23865" x1="22.7586" y1="-21.7738" x2="77.5901" y2="63.8423"
                                gradientUnits="userSpaceOnUse">
                    <stop stopColor="#F83700"/>
                    <stop offset="1" stopColor="#F7CB2A"/>
                </linearGradient>
                <linearGradient id="paint1_linear_971_23865" x1="21.1034" y1="-11.7444" x2="66.8186" y2="25.0977"
                                gradientUnits="userSpaceOnUse">
                    <stop stopColor="#F83700"/>
                    <stop offset="1" stopColor="#F7CB2A"/>
                </linearGradient>
            </defs>
        </svg>
    );
};